import { Loading, OmnijusSelectField, SelectObject } from "@omnijus/common";
import React, { useEffect, useState } from "react";

interface OmnijusCampoPerfilProps {
    hideLabel?: boolean;
    promise?: Promise<SelectObject[]>;

    name?: string;
    label?: string;
    isMulti?: boolean;
    value?: any;
}

export const OmnijusFiltroPerfil = (props: OmnijusCampoPerfilProps) => {
    const name = props.name || "idPerfil";
    const [promise, setPromise] = useState<Promise<SelectObject[] | undefined>>();

    useEffect(() => {
        setPromise(props.promise);
    }, [props.promise]);

    return (
        <Loading promise={promise}>
            {(opcoes) => (
                <OmnijusSelectField
                    name={name}
                    label={props.hideLabel ? undefined : props.label || "Perfil"}
                    isMulti={props.isMulti}
                    options={opcoes}
                />
            )}
        </Loading>
    );
};
